/**
 * Returns the user name and password for the GUEST User account
 * @returns {{password: string, userName: string}}
 */
export const getGuestUserAccount = () => ({
  userName: 'GUEST',
  password: 'nn07gV0Q&t^A'
})
